var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.02,
    y1: 1.069,
    x2: -0.081,
    y2: 0.085,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7166"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_184",
    "data-name": "Groupe 184",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook-logo",
    transform: "translate(20.654 13.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_134",
    "data-name": "Trac\\xE9 134",
    d: "M37.489.006,33.648,0c-4.316,0-7.1,2.963-7.1,7.55v3.481H22.681a.615.615,0,0,0-.6.626V16.7a.615.615,0,0,0,.6.626h3.862V30.054a.615.615,0,0,0,.6.626h5.039a.615.615,0,0,0,.6-.626V17.327h4.516a.615.615,0,0,0,.6-.626l0-5.044a.638.638,0,0,0-.177-.442.594.594,0,0,0-.427-.184H32.79V8.08c0-1.418.326-2.138,2.11-2.138h2.588a.615.615,0,0,0,.6-.626V.632A.615.615,0,0,0,37.489.006Z",
    transform: "translate(-22.077)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f7a4dcc231ce62e558e285fd8a85beba.svg";
export { ForwardRef as ReactComponent };